<template>
    <list-group-item :action="clickAction" color="primary">
        <div class="d-flex">
            <strong>Requested Booking #{{ this.booking.id }}</strong>
            <div class="ms-auto">
                {{ booking.checkInDateTime.format('n/j/Y') }} - {{ booking.checkOutDateTime.format('n/j/Y') }}
            </div>
        </div>
        <div v-if="booking.property" class="small">
            <strong>{{ booking.property.name }}</strong>
            <property-address :property="booking.property" class="x-small text-muted"/>
        </div>
        <ui-button size="sm" :block="true">
            Accept or Decline
        </ui-button>
    </list-group-item>
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';
    import PropertyAddress from '@/components/Content/Properties/Address.vue';
    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            PropertyAddress,
            ...UIComponents,
        },

        props: {
            booking: {
                type: ApiObject,
                required: true,
            },
        },

        emits: ['click'],

        methods: {
            clickAction() {
                this.$emit('click');
                this.$router.push('/owners/bookings/requested/'+this.booking.id);
            },
        },
    }
</script>